/* eslint-disable */

/** unique or primary key constraints on table "argo.material_udf_data" */
export enum ArgoMaterialUdfDataConstraint {
  /** unique or primary key constraint on columns "material_udf_id" */
  MaterialUdfDataPkey = 'material_udf_data_pkey',
  /** unique or primary key constraint on columns "udf_column_id", "context_id", "material_id" */
  MaterialUdfUnique = 'material_udf_unique'
}

/** select columns of table "argo.material_udf_data" */
export enum ArgoMaterialUdfDataSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialId = 'material_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  NumVal = 'num_val',
  /** column name */
  StrVal = 'str_val',
  /** column name */
  UdfColumnId = 'udf_column_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** update columns of table "argo.material_udf_data" */
export enum ArgoMaterialUdfDataUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialId = 'material_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  NumVal = 'num_val',
  /** column name */
  StrVal = 'str_val',
  /** column name */
  UdfColumnId = 'udf_column_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

